import React from "react"
import { FormattedMessage, useIntl } from "react-intl"
import { Grid, useMediaQuery, Link, Box } from "@mui/material/"
import { styled } from "@mui/material/styles"

import ContentsTitle from "atoms/text/ContentsTitle"
import ContentsText from "atoms/text/ContentsText"
import ContentsSubText from "atoms/text/ContentsSubText"
import { getLocaleJaOrEnInitialUpper } from "locale.js"

const StyledContainer = styled(Box)(({ theme }) => ({
  position: "relative",
  maxWidth: "1004px",
  paddingTop: "70px",
  paddingBottom: "70px",
  paddingLeft: "30px",
  paddingRight: "30px",
  margin: "0 auto",
  [`@media (min-width:735px)`]: {
    paddingLeft: "45px",
    paddingRight: "45px",
  },
  [`@media (min-width:1095px)`]: {
    paddingLeft: "60px",
    paddingRight: "60px",
  },
}))

const ContentsTextSpaceLine = styled(Grid)(({ theme }) => ({
  paddingBottom: "27px",
  [theme.breakpoints.down("xs")]: {
    paddingBottom: "16px",
  },
}))

const SubTextLink = styled(Link)(({ theme }) => ({
  paddingLeft: "10px",
  paddingRight: "15px",
}))

const TopSummary = () => {
  const isTabletPC = useMediaQuery("(min-width:600px)")
  const intl = useIntl()

  const titleValue = intl.formatMessage({ id: "TopSummary.Title" })
  const subTextStart = intl.formatMessage({ id: "TopSummary.SubTextStart" })
  const subTextLink = intl.formatMessage({ id: "TopSummary.SubTextLink" })
  const subTextEnd = intl.formatMessage({ id: "TopSummary.SubTextEnd" })

  const dataGa = "privacyLink" + getLocaleJaOrEnInitialUpper()

  return (
    <StyledContainer>
      <Grid container>
        <ContentsTextSpaceLine item xs={12}>
          <ContentsTitle>{titleValue}</ContentsTitle>
        </ContentsTextSpaceLine>
        <Grid item xs={12}>
          <ContentsText>
            <FormattedMessage
              id="TopSummary.Text"
              values={{
                linebreak: isTabletPC ? <br /> : "",
              }}
            />
          </ContentsText>
          <ContentsSubText>
            {subTextStart}
            <SubTextLink
              id="privacyLink"
              href="https://www.docomo.ne.jp/utility/personal_data/measure/index.html?utm_source=corp_other&utm_medium=other&utm_campaign=corp_201912_from-pdd17"
              target="_blank"
              data-ga={dataGa}
              underline="hover"
            >
              {subTextLink}
            </SubTextLink>
            {subTextEnd}
          </ContentsSubText>
        </Grid>
      </Grid>
    </StyledContainer>
  )
}

export default TopSummary
